// Below this a percentage rounds to 0.0% and says nothing.
const MIN_REVIEWED_PERCENT = 0.1;

/**
 * How much of an entity's items its owner has reviewed, as a facts-line
 * segment — null when there is too little to report. A private-namespace
 * figure: only a private copy counts what its owner has read.
 */
export default function reviewedFact(stats) {
  const { totalItems, totalItemsReviewed } = stats || {};
  const percent = totalItems && totalItemsReviewed
    ? (totalItemsReviewed / totalItems) * 100
    : 0;

  return percent >= MIN_REVIEWED_PERCENT
    ? `${parseFloat(percent.toFixed(1))}% reviewed`
    : null;
}
